// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\App\MorePage\MorePageViewModel.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { PilotsMorePage, PilotsMorePageData, PilotsMorePageOptions } from 'data/models/PilotsMorePage';

// MorePageData is the class that MorePage serializes to/from
export interface MorePageData {
    UserId : number;
	
    Pilots : PilotsMorePageData | null;
	
    CanManageBerths : boolean;
    CanRequestBerths : boolean;
    CanSiteAdmin : boolean;
}

// MorePageOptions is the class which may be passed to the MorePage constructor to define optional initial data values
export interface MorePageOptions {
    UserId : number;
	
    Pilots? : PilotsMorePageOptions | null;
	
    CanManageBerths? : boolean;
    CanRequestBerths? : boolean;
    CanSiteAdmin? : boolean;
}

export class MorePage {
    public UserId : DataSignal<number>;
	
    public Pilots : DataSignal<PilotsMorePage | null>;
	
    public CanManageBerths : DataSignal<boolean>;
    public CanRequestBerths : DataSignal<boolean>;
    public CanSiteAdmin : DataSignal<boolean>;

    constructor();
    constructor(data : MorePageOptions);
    constructor(data: MorePageOptions | null = null) {
        this.UserId = jsonableObservable(S.value<number>(data && data.UserId !== undefined ? data.UserId : 0));
	    
        this.Pilots = S.value<PilotsMorePage | null>(null);
	    
        this.CanManageBerths = jsonableObservable(S.value<boolean>(data && data.CanManageBerths !== undefined ? data.CanManageBerths : false));
        this.CanRequestBerths = jsonableObservable(S.value<boolean>(data && data.CanRequestBerths !== undefined ? data.CanRequestBerths : false));
        this.CanSiteAdmin = jsonableObservable(S.value<boolean>(data && data.CanSiteAdmin !== undefined ? data.CanSiteAdmin : false));
    }

    static key(obj : MorePage) {
        return obj.UserId();
    }
    
    static dataKey(obj : MorePageOptions) {
        return obj.UserId;
    }

    static update(obj : MorePage, data : MorePageOptions) {
        S.freeze(() => {
            if (data.UserId !== undefined) obj.UserId(data.UserId);
	        
	        
            if (data.CanManageBerths !== undefined) obj.CanManageBerths(data.CanManageBerths);
            if (data.CanRequestBerths !== undefined) obj.CanRequestBerths(data.CanRequestBerths);
            if (data.CanSiteAdmin !== undefined) obj.CanSiteAdmin(data.CanSiteAdmin);
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/MorePage.ts